module.exports = __webpack_public_path__ + "static/media/card-3.2001ce1e.jpeg";